import React, {Component} from 'react';
import {Button, Dialog, List, NavBar, Toast} from "antd-mobile";
import axios from "axios";
import ApiService from "../../utils/ApiService";
import {useNavigate} from "react-router-dom";
import {LoadingContext} from "../../components/Loading/LoadingContext";

function My(props:any) {
  const navigate = useNavigate()
  const { setIsLoading } = React.useContext(LoadingContext);
  const {current:tempObj}=React.useRef<any>({name:'load...',username:'load...'});
  const [_,upPage] = React.useState(Math.random());

  const handleLoginOut=async () => {
    const ret = await ApiService.ubind();
    if (ret && ret.code == 1) {
      Toast.show("解绑成功")
      window.localStorage.clear()
      window.location.href = '/api/wechat/getopenid';
    } else if (ret) {
      Toast.show(ret.message)
    }
  }

  React.useEffect(()=>{
    getInfo();
  },[])

  const getInfo = async () => {
    setIsLoading(true);
    const ret = await ApiService.getMyInfo();
    setIsLoading(false);
    if (ret && ret.code == 1) {
      tempObj.name = ret.data.name;
      tempObj.username = ret.data.username;
    } else if (ret) {
      Toast.show(ret.message)

    }
  }

    return (
      <div>
        <NavBar backArrow={<></>}>个人中心</NavBar>
        <div style={{height:160,width:'100%',background:'#9CD1FF',overflow:'hidden',}}>
          <div style={{margin:20}}>
            <div style={{background:'#fff',width:'100%',height:'120px',borderRadius:'10px',overflow:'hidden'}}>
              <div style={{margin:'20px 20px 0'}}>
                <img src={require('../../static/img/bak.jpg')}  style={{width:'80px',height:'80px',borderRadius:'10px'}}/>
                <span style={{display:'inline-block',height:'80px',verticalAlign:'middle',marginLeft:15,marginTop:-30,fontSize:20}}>
                  欢迎您: {tempObj.name}<br/>
                  <span style={{fontSize:13,color:'#949494'}}>账号:{tempObj.username}</span>
                </span>

              </div>
            </div>

          </div>
        </div>
        <div style={{margin:"10px"}}>
          <List mode='card' header='常用操作'>
            <List.Item extra='' onClick={()=>{
              navigate('/collect/list');
            }}>
              信息采集
            </List.Item>
            <List.Item extra='' onClick={()=>{
              navigate('/device/bind');
            }}>
              设备绑定
            </List.Item>
            <List.Item extra='' onClick={()=>{
              navigate('/warn/list');
            }}>
              预警处置
            </List.Item>
            <List.Item onClick={()=>{
              Dialog.confirm({
                content: '您确认解除当前账号和微信的绑定吗',
                onConfirm: async () => {
                  handleLoginOut()
                },
              })
            }}>解除绑定</List.Item>
          </List>
        </div>
      </div>
    );
}

export default My;
